module.exports = __webpack_public_path__ + "static/media/IntroDemo10-blank.7a3a87c7.png";